import { Row } from 'antd';
import React, {useEffect, useState} from 'react';
import CustomerOfferFilters from './CustomerOfferFilters';
import CustomerOfferList from './CustomerOfferList';
import { ProjectTwoTone } from '@ant-design/icons';
import { customerBids } from '../../../services/serviceReports';

const CustomerOfferContainer = ({customer, baseDates}) => {
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const requestObj = {
            customerId: customer,
            startDate: baseDates[0],
            endDate: baseDates[1],
            brandId: null,
            bidStatus: null
        };
        getCustomerBids(requestObj);
    }, [customer, baseDates]);

    const getCustomerBids = (requestObj) => {
        customerBids(requestObj)
            .then(({data}) => {
                if(data) {
                    const organized = organizeBidData(data);
                    setTableData(organized);
                }
        })
    }

    const organizeBidData = (data) => {
        const memoObj = {};
        data.forEach(bidItem => {
            if(memoObj.hasOwnProperty(bidItem.bn)) {
                memoObj[bidItem.bn].cl.push({c: bidItem.c, pet: bidItem.pet, pit: bidItem.pit})
            }else {
                memoObj[bidItem.bn] = {
                    cl: [{c: bidItem.c, pet: bidItem.pet, pit: bidItem.pit}],
                    b: bidItem.b,
                    bn: bidItem.bn,
                    d: bidItem.d,
                    e: bidItem.e,
                    id: bidItem.id
                }
            }

        });

        return Object.values(memoObj);
    };

    const updater = (fields) => {
        let sDate = fields.dateRanges ? fields.dateRanges[0] : baseDates[0];
        let eDate = fields.dateRanges ? fields.dateRanges[1] : baseDates[1];

        const requestObj = {
            customerId: customer,
            startDate: sDate,
            endDate: eDate,
            brandId: fields.brandId || null,
            bidStatus: fields.bidStatus
        };
        getCustomerBids(requestObj);
    };

    return(
        <>
            <Row align={'middle'} style={{marginBottom: '16px'}}>
                <ProjectTwoTone />
                <h4 style={{marginBottom: 0, marginLeft: '6px'}}>Teklif Raporları</h4>
            </Row>
            <CustomerOfferFilters updateSignal={updater} />
            <CustomerOfferList tableData={tableData} />
        </>
    )
};

export default CustomerOfferContainer;